/**
 * Shared thresholds for listing-form option controls.
 * Keep as one constant so taxonomy growth can't silently create a chip wall.
 */
export const CHIP_LIMIT = 10;

export const OPTION_CONTROL_SEGMENTED = 'segmented';
export const OPTION_CONTROL_CHIPS = 'chips';
export const OPTION_CONTROL_SEARCHABLE = 'searchable';

/**
 * Pick control mode from option count.
 * 1 → single chip
 * 2-3 → equal-width segmented row
 * 4-CHIP_LIMIT → wrapping chips
 * CHIP_LIMIT+1 → searchable select
 *
 * @param {number} optionCount
 * @param {number} [chipLimit]
 * @returns {'segmented'|'chips'|'searchable'|null}
 */
export const getOptionControlMode = (optionCount, chipLimit = CHIP_LIMIT) => {
  if (!optionCount || optionCount < 1) {
    return null;
  }
  if (optionCount === 1) {
    return OPTION_CONTROL_CHIPS;
  }
  if (optionCount <= 3) {
    return OPTION_CONTROL_SEGMENTED;
  }
  if (optionCount <= chipLimit) {
    return OPTION_CONTROL_CHIPS;
  }
  return OPTION_CONTROL_SEARCHABLE;
};
